import { IChildForm } from "../../../";
import { formatPhoneNumber } from "../../../../../utils/phoneUtils";
import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

const DriverChildForm = (props: IChildForm) => {
    return (
        <div className="w-full my-6 p-6 pb-0 border rounded">

            <div className={`flex justify-between w-full gap-6 ${isMobile() ? 'flex-wrap' : ''}`}>
                {!props.hiddenFields.includes("driverName") && <div className={`form-group form-group-lg w-full ${props.hasError && props.requiredFields.includes('driverName') && !props.occurrence?.driverName ? 'has-error' : ''}`}>
                    <label htmlFor="driverName" className="truncate">Nome do motorista{props.requiredFields.includes("driverName") ? ' *' : ''}</label>
                    <input
                        type="text"
                        className="form-control"
                        id="driverName"
                        placeholder="Nome do motorista"
                        disabled={props.disabledAllFields || props.disabledFields.includes("driverName")}
                        value={props.occurrence?.driverName}
                        onChange={(e) => props.occurrence && props.setOccurrenceValue('driverName', e.target.value)}
                        maxLength={100}
                    />
                </div>}

                {!props.hiddenFields.includes("driverLicenseNumber") && <div className={`form-group form-group-lg w-full ${props.hasError && props.requiredFields.includes('driverLicenseNumber') && !props.occurrence?.driverLicenseNumber ? 'has-error' : ''}`}>
                    <label htmlFor="driverLicenseNumber" className="truncate">CNH do motorista{props.requiredFields.includes("driverLicenseNumber") ? ' *' : ''}</label>
                    <input
                        type="text"
                        className="form-control"
                        id="driverLicenseNumber"
                        placeholder="CNH do motorista"
                        disabled={props.disabledAllFields || props.disabledFields.includes("driverLicenseNumber")}
                        value={props.occurrence?.driverLicenseNumber}
                        onChange={(e) => props.occurrence && props.setOccurrenceValue('driverLicenseNumber', e.target.value)}
                        maxLength={12}
                    />
                </div>}

                {!props.hiddenFields.includes("driverPhone") && <div className={`form-group form-group-lg w-full ${props.hasError && props.requiredFields.includes('driverPhone') && !props.occurrence?.driverPhone ? 'has-error' : ''}`}>
                    <label htmlFor="driverPhone" className="truncate">Telefone do motorista{props.requiredFields.includes("driverPhone") ? ' *' : ''}</label>
                    <input
                        type="text"
                        className="form-control"
                        id="driverPhone"
                        placeholder="Telefone do motorista"
                        disabled={props.disabledAllFields || props.disabledFields.includes("driverPhone")}
                        value={props.occurrence?.driverPhone}
                        onChange={(e) => {
                            const formattedPhoneNumber = formatPhoneNumber(e.target.value);
                            props.occurrence && props.setOccurrenceValue('driverPhone', formattedPhoneNumber);
                        }}
                        maxLength={15}
                    />
                </div>}

            </div>
        </div>
    );
}

export default DriverChildForm;